import styled from 'styled-components'
import { Button } from '../../../../buttons/Button/Button'
import { RadioItem } from '../../../../controls/Radio/Radio'
import { NumberInput } from '../../../../text-fields/NumberInput/NumberInput'

export const RadioOption = styled(RadioItem)`
  & :last-child {
    margin-left: 40px;
  }
  & > span {
    font-size: 14px;
    line-height: 20px;
  }
`

export const SubmitButton = styled(Button)`
  width: 186px;
  height: 48px;
  margin-top: 24px;
  margin-bottom: 40px;
`

export const Quantity = styled(NumberInput)`
  margin-top: 16px;
  margin-bottom: 16px;
`

export const LabelCrops = styled.div`
  max-width: 340px;
  margin-top: 24px;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
`

export const LabelFertilizer = styled(LabelCrops)`
  margin-bottom: 16px;
`
